import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import PaymentSuccessIcon from "../../assets/img/PaymentOnboardingSuccess.svg";
import User from "../../services/user.service";
import Storage from '../../services/storage.service';
import GTMService from "../../services/gtm.service";
import Settings from '../../services/settings.service';
import FirebaseAnalytics from '../../services/analytics.service';
import CONSTANTS from '../../services/constants.service';
import SpinnerTimeLoader from '../shared/timeLoading';
import Flow from '../../services/flow.service';
import DownloadApps from '../shared/DownloadApps';
const subscriptions = [];
const PaymentSuccess = props => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [loader, setLoader] = useState(false);

    const paymentHandling = () => {
        FirebaseAnalytics.button_clicked(CONSTANTS.PAYMENT_SUCCESS_SCREEN, "buttons_continue");
        setLoader(true);
        User.fetchFlowStatus().then(() => {
            Flow.goTo();
            Storage.clear("paymentSuccess");
            Storage.clear("paymentPrice");
            Storage.clear("calledFeatureConfirmation");
            Storage.clear("confirmSuccess");
            Storage.clear("confirmFailed");
            setLoader(false);
        })

    }
    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        GTMService.action_gtm_on_payment_done();
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, []);

    return (<div className="payment-summary-success-failure">
        {loader ? <SpinnerTimeLoader /> :
            <div className="payment-summary-failure">
                <img src={PaymentSuccessIcon} alt={""}></img>
                <div className='payment-success-title'>
                    {translationKeys["payment_completed_successfully"]}
                </div>
                <div className='payment-success-desc'>
                    {translationKeys["payment_success_desc"]}
                </div>
                <button className="common-button" onClick={paymentHandling}> {translationKeys["buttons_continue"]}</button>
                <DownloadApps
                    info={translationKeys["scr_3.3.3_app_download_info"]}
                    classes={"download-apps"}
                    google_play_link={Settings.google_play_link}
                    app_store_link={Settings.app_store_link}
                    huawei_store_link={Settings.huawei_store_link}
                />
            </div>
        }
    </div>
    )
}

export default PaymentSuccess;